import { render } from "./zipCode.vue?vue&type=template&id=c45593fc"
import script from "./zipCode.vue?vue&type=script&lang=js"
export * from "./zipCode.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HP\\gitlab\\vue3.0\\pack\\vue-addresstw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__